import React, { useState } from "react";
import { Button } from "antd";
import AddElectionDataModal from "./AddElectionData";

const TabTwo = ({ survey,filters }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      {/* TOP RIGHT BUTTON */}
      <div className="absolute top-20 right-[1%] z-[9999]">
        <Button
          type="primary"
          size="large"
          className="bg-[#0b65c2] hover:bg-[#123865] shadow-xl rounded-full px-6"
          onClick={() => setOpenModal(true)}
        >
          Add Election Data
        </Button>
      </div>
      {openModal && (
        <AddElectionDataModal
          survey={survey}
          onClose={() => setOpenModal(false)}
          onSave={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default TabTwo;
